import React, { ReactNode } from 'react';

import Span from 'components/elements/span';
import Box from 'components/elements/Box';
import Menu from '../../Menu/Menu';
import { ListItemBox } from 'components/base/Dropdown/shared/styles';
import { tooltipContent } from 'helpers/getTooltipContent';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import { ReactComponent as regionInfoIcon } from 'icons/icon-info.svg';
import { FlagImage } from 'components/base/TopicFiltersDropdown/RegionDropdown/index';
import { ListItemBox as ListItemBoxWithHover } from './TimeframeDropdown.style';
import DropdownButton from '../DropdownButton';
import DropdownWrapper from '../DropdownWrapper';

function ListLabel(): ReactNode {
  return (
    <ListItemBox>
      <Span marginLeft={1} alignSelf="auto">
        Select a timeframe:
      </Span>
    </ListItemBox>
  );
}

const ListItem: React.FC<IListItemProps> = (props) => {
  const { item, isActive, isTooltipEnabled } = props;

  return (
    <ListItemBoxWithHover
      isActive={isActive}
      alignContent="stretch"
      paddingRight={2}
      paddingLeft={3}
      py={2}
      minWidth="270px"
    >
      <Span marginLeft={1} alignSelf="auto">
        {item.label}
      </Span>
      {item.label === 'This week to date' && isTooltipEnabled && (
        <TippyToolTip
          tooltipContent={tooltipContent}
          enabled
          offset={[10, 25]}
          maxWidth="170px"
        >
          <Box alignSelf="auto" display="flex" ml={3}>
            <FlagImage as={regionInfoIcon} width={16} height={16} />
          </Box>
        </TippyToolTip>
      )}
    </ListItemBoxWithHover>
  );
};

const getButtonWithDefaultLabel = (
  selectedItem?: any,
  defaultLabel?: string
): React.FC<any> => {
  const LabeledButton: React.FC<any> = (props: any) => {
    return (
      <DropdownButton
        {...props}
        selectedItem={selectedItem}
        defaultLabel={defaultLabel}
        dropdownType="Timeframe"
      />
    );
  };
  return LabeledButton;
};

const TimeframeDropdown: React.FC<ITimeframeDropdownProps> = (props) => {
  const {
    items,
    selectedItem,
    onChange,
    disabled,
    itemToString,
    defaultLabel,
  } = props;

  // selectedItem can be undefined which will trigger React into thinking this is a controlled component,
  // when it then switches to an actual value runtime errors will be thrown since React will figure
  // we're trying to switch a controlled component into an uncontrolled component. Null is a valid value,
  // therefore we add this seemingly weird check.
  return (
    <DropdownWrapper label="TIMEFRAME">
      <Menu
        items={items}
        selectedItem={selectedItem || null}
        onChange={onChange}
        disabled={disabled}
        ListLabel={ListLabel}
        itemToString={itemToString}
        Button={getButtonWithDefaultLabel(selectedItem, defaultLabel)}
        Item={ListItem}
      />
    </DropdownWrapper>
  );
};

interface ITimeframeDropdownProps {
  items: any[];
  selectedItem: any;
  onChange: (item: any) => void;
  disabled?: boolean;
  itemToString?: (item: any) => string | null;
  defaultLabel?: string;
}

interface IListItemProps {
  item: any;
  isActive?: boolean;
  isTooltipEnabled?: boolean;
}

export default TimeframeDropdown;
